import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchComponent }      from '../search/search.component';
//import { BarChartComponent }    from '../bar-chart/bar-chart.component';
//import { ConcordanceComponent } from '../concordance/concordance.component';
//import { AgeChartComponent }	   from '../AgeChart/age.component';
//import { MapComponent }		   from '../map/map.component';
//import { ResultsComponent }	   from '../results/results.component';
//import { ScatterChartComponent } from '../scatter/scatter.component';
//import { SummaryComponent }		from '../summary/summary.component';
//import { StaticAboutComponent }   from '../static-about/static-about.component';
//import { StaticContactComponent }   from '../static-contact/static-contact.component';

const routes: Routes = [
  { path: '', redirectTo: '/search', pathMatch: 'full' },
//{ path: 'student/:query', component: SearchComponent },
//{ path: 'student', component: SearchComponent },
  { path: 'search/:query', component: SearchComponent },
  { path: 'search', component: SearchComponent },
//  { path: 'social-class', component: BarChartComponent },
//  { path: 'concordance',	component: ConcordanceComponent },
//  { path: 'age-chart', component: AgeChartComponent },
//  { path: 'map', component: MapComponent },
//  { path: 'speakers', component: ResultsComponent },
//  { path: 'gender', component: ScatterChartComponent },
//  { path: 'summary', component: SummaryComponent }
//  { path: 'about',     component: StaticContactComponent},
//  { path: 'contact',   component: StaticAboutComponent},
];
@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/app-routing/app-routing.module.ts